module.exports = __webpack_public_path__ + "static/media/sendMessage.9655f6c7.png";